$.fn.RapportTable = function(_rapport) {
	var self = this;
	self.request = undefined
	self.details = {
		pub: $('.rapport-details-table--pub'),
		tv: $('.rapport-details-table--tv'),
		vhc: $('.rapport-details-table--vhc'),
	}
	self.status = {
		main_loaded: false,
		pub_loaded: false,
		tv_loaded: false,
		vhc_loaded: false,
	}

	self.reset = function() {
		if (self.request != undefined) {
			self.request.abort()
		}
		if (self.status.main_loaded) {
			self.DataTable().clear().destroy()
			self.find('thead tr').remove()
			self.find('tfoot tr').remove()
			self.status.main_loaded = false
			self.off('click', 'tr')
		}
		$('.rapport-table__details').addClass('d-none')
	}

	self.update = function() {
		var contacts = [], fields = [], years = [], period = [];
		contacts = _rapport.filters.find('select[name="contact"]').val();
		if (_rapport.filters.find('input[name="single_contact"]').length) {
			contacts = [_rapport.filters.find('input[name="single_contact"]').val()]
		}
		if (!contacts || !contacts.length) {
			return
		}
		_rapport.filters.find('input[name="fields[]"]:checked').each(function() {
			fields.push($(this).val());
		})
		if (_rapport.filters.period_type == 'years') {
			years = [_rapport.filters.find('select[name="year_start"]').val(), _rapport.filters.find('select[name="year_end"]').val()];
		}
		if (_rapport.filters.period_type == 'period') {
			period = [_rapport.filters.find('input[name="period_start"]').val(), _rapport.filters.find('input[name="period_end"]').val()];
		}

		if (self.request != undefined) {
			self.request.abort()
		}

		self.request = $.ajax('/rapport/data', {
			type: 'POST',
			data: {
				contact: contacts,
				fields: fields,
				years: years,
				period: period,
			},
			dataType: 'json',
			complete: function(x) {
				self.request = undefined
				var data = JSON.parse(x.responseText)
				if (self.status.main_loaded) {
					self.DataTable().clear().destroy()
					self.find('thead tr').remove()
					self.status.main_loaded = false
					self.off('click', 'tr')
				}
				if (self.status.pub_loaded) {
					self.status.pub_loaded = false
					self.details.pub.DataTable().clear().destroy()
					self.details.pub.find('thead tr').remove()
					self.details.pub.find('tfoot').remove()
				}
				if (self.status.tv_loaded) {
					self.status.tv_loaded = false
					self.details.tv.DataTable().clear().destroy()
					self.details.tv.find('thead tr').remove()
					self.details.tv.find('tfoot').remove()
				}
				if (self.status.vhc_loaded) {
					self.status.vhc_loaded = false
					self.details.vhc.DataTable().clear().destroy()
					self.details.vhc.find('thead tr').remove()
					self.details.vhc.find('tfoot').remove()
				}
				$('.rapport-table__details').addClass('d-none')
				self.find('tfoot').remove()
				if (data.data.length > 1) {
					self.append('<tfoot><tr><th colspan="2">Total&thinsp;:</th></tr></tfoot>');
					var tfoot = self.find('tfoot tr');
					for (var i = 2; i < data.columns.length; i++) {
						tfoot.append('<th></th>');
					}
				}

				var mainTable = self.DataTable({
					language: { url: '/assets/libraries/DataTables-fr_FR.json' },
					order: [[1, 'asc']],
					layout: {
						topStart: null,
						topEnd: null,
						bottomStart: null,
						bottomEnd: null,
					},
					paging: false,
					data: data.data,
					columns: data.columns,
					footerCallback: function (row, data, start, end, display) {
						var api = this.api();
						api.columns().every(function (index) {
							if (index >= 2) {
								var total = 0;
								api.rows({ filter: 'applied' }).every(function (rowIndex, tableLoop, rowLoop) {
									var cellData = api.cell(rowIndex, index).data();
									total += parseFloat(cellData.replace(' ', '').replace(',', '.')) || 0;
								});
								$(api.column(index).footer()).html(total.toLocaleString('fr-CA', {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2
								}) + '&thinsp;$');
							}
						});
					},
					initComplete: function() {
						self.status.main_loaded = true
						var thead = $('<tr class="rapport-years"><th colspan="1">&nbsp;</th></tr>')
						if (data.data.length > 0 && period && period.length == 2) {
							thead.append('<th class="year" colspan="' + fields.length + '">' + period[0] + ' — ' + period[1] + '</th>');
						} else if (data.data.length > 0 && years && years.length == 2) {
							for (var i = years[0]; i <= years[1]; i++) {
								thead.append('<th class="year" colspan="' + fields.length + '">' + i + '</th>');
							}
						}
						self.find('thead tr').before(thead.clone());
					},
				})

				self.on('click', 'tr', function() {
					var data = mainTable.row(this).data();
					if (data && 'id' in data) {
						if (!$('body').hasClass('solis')) {
							display_details(data.id, 'pub');
							display_details(data.id, 'vhc');
						}
						display_details(data.id, 'tv');
						$('.rapport-table__details').removeClass('d-none')
					}
				});

				function display_details(contact_id, type) {
					if (data.details_data.length < 1) {
						return;
					}

					if (self.status[type + '_loaded']) {
						self.status[type + '_loaded'] = false
						self.details[type].DataTable().clear().destroy()
					}
					self.details[type].find('thead tr').remove()
					self.details[type].find('tfoot').remove()
					self.details[type].append('<tfoot><tr><th colspan="2">Total&thinsp;:</th></tr></tfoot>');
					var tfoot = self.details[type].find('tfoot tr');
					for (var i = 2; i < data.columns.length; i++) {
						tfoot.append('<th></th>');
					}

					let details_table = self.details[type].DataTable({
						language: { url: '/assets/libraries/DataTables-fr_FR.json' },
						order: [[0, 'asc']],
						paging: false,
						data: data.details_data,
						columns: data.details_columns,
						layout: {
							topStart: ['search', {
								buttons: [
									{
										extend: 'excel',
										text: 'Télécharger Excel',
										className: 'btn btn-primary btn-sm',
										exportOptions: {
											modifier: {
												page: 'current'
											},
											format: {
												body: function (data, row, column, node) {
													data = $(node).text().trim()
													if (column === 0) {
														return data.split(' ')[0].trim();
													}
													if (column >= 2) {
														let numericValue = parseFloat(data.replace(',', '.').replace(/[^\d.-]/g, ''));
														return !isNaN(numericValue) ? numericValue : data;
													}
													return data;
												}
											}
										},
										init: function (api, node, config) {
											$(node).html('<span class="material-symbols-outlined mr-1">download</span><span>Télécharger Excel</span>');
										},
										// customize: function (xlsx) {
										// 	// let sheet = xlsx.xl.worksheets['sheet1.xml'];
										// 	// $('c[r^="C"]', sheet).each(function () {
										// 	// 	$(this).attr('s', '5');
										// 	// });
										// }
									}
								],
							}],
							topEnd: null,
							bottomStart: null,
							bottomEnd: null,
						},
						footerCallback: function (row, data, start, end, display) {
							var api = this.api();
							api.columns().every(function (index) {
								if (index >= 2) {
									var total = 0;
									api.rows({ filter: 'applied' }).every(function (rowIndex, tableLoop, rowLoop) {
										var cellData = api.cell(rowIndex, index).data();
										total += parseFloat(cellData.replace(' ', '').replace(',', '.')) || 0;
									});
									$(api.column(index).footer()).html(total.toLocaleString('fr-CA', {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2
									}) + '&thinsp;$');
								}
							});
						},
						initComplete: function() {
							$('.col-md-auto').addClass('col')
							$('.dt-container > .row:first-child').css('visibility', 'visible')
							$(".dt-search input[type=search]").attr("autocomplete", "new-password").wrap('<div class="form-input-icon"></div>');
							$(".dt-search input[type=search]").before('<i class="icmn-search"></i>').removeClass('input-sm').addClass("form-control").css('padding-right', '0.75em');

							self.status[type + '_loaded'] = true
							var table_title = '', search_key = ''
							switch (type) {
								case 'tv':
								table_title = 'AUTRES';
								search_key = '(?=.*_t2_)(?=.*c' + contact_id + '_)';
								break;
								case 'pub':
								table_title = 'PUBLICITÉ';
								search_key = '(?=.*_t1_)(?=.*c' + contact_id + '_)';
								break;
								case 'vhc':
								table_title = 'VOIX HORS-CHAMP';
								search_key = '(?=.*_t4_)(?=.*c' + contact_id + '_)';
								break;
							}
							if (period && period.length == 2) {
								var tr_years = self.find('thead tr:first').clone();
								tr_years.find('th:first').attr('colspan', 2).html(table_title);
								self.details[type].find('thead tr').before(tr_years);
							} else if (years && years.length == 2) {
								var tr_years = self.find('thead tr:first').clone();
								tr_years.find('th:first').attr('colspan', 2).html(table_title);
								self.details[type].find('thead tr').before(tr_years);
							}
							var table = this.api();
							table.column(0).search(search_key, true, false).draw()
							if ($('#custom-search input').val()) {
								table.column(1).search($('#custom-search input').val()).draw()
							}
						},
					})

					/* Live reference search */
					$('#custom-search input').on('keyup', function() {
						details_table.column(1).search($(this).val()).draw()
					})
				}
			}
		})
	}

	return function() {
		return self;
	}();
}

$.fn.RapportFilters = function(_rapport) {
	var self = this;
	self.period_type = 'period'

	self.period_type_changed = function() {
		self.period_type = $(this).val()
		if (self.period_type == 'period') {
			self.find('.period-date-picker').parent().removeClass('d-none')
			self.find('.year-picker').parent().addClass('d-none')
		} else {
			self.find('.period-date-picker').parent().addClass('d-none')
			self.find('.year-picker').parent().removeClass('d-none')
		}
	}

	self.period_changed = function(e) {
		let changedField = $(e.currentTarget).find('input').attr('name'),
		periodStartValue = self.find('input[name="period_start"]').val(),
		periodEndValue = self.find('input[name="period_end"]').val()
		if (changedField == 'period_start' && periodStartValue > periodEndValue) {
			self.find('input[name="period_end"]').val(periodStartValue)
		} else if (changedField == 'period_end' && periodEndValue < periodStartValue) {
			self.find('input[name="period_start"]').val(periodEndValue)
		}
	}

	self.year_changed = function(e) {
		let changedField = $(e.currentTarget).attr('name'),
		yearStartValue = self.find('select[name="year_start"]').val(),
		yearEndValue = self.find('select[name="year_end"]').val()
		if (changedField == 'year_start' && yearStartValue > yearEndValue) {
			self.find('select[name="year_end"]').find('option[value="' + yearStartValue + '"]').prop('selected', true);
    	self.find('select[name="year_end"]').trigger('change');
		} else if (changedField == 'year_end' && yearEndValue < yearStartValue) {
			self.find('select[name="year_start"]').find('option[value="' + yearEndValue + '"]').prop('selected', true);
    	self.find('select[name="year_start"]').trigger('change');
		}
	}

	return function() {
		self.find('.select2[multiple]').each(function() {
			$(this).select2(select2WithCompany({
				allowClear: true,
			}));
			$(this).on('select2:select', function(e) {
				if (e.params.data.id === 'select_all') {
					self.find('.select2[name="contact"]').find('option').not('[value="select_all"]').prop('selected', true);
					$('option[value="select_all"]').prop('selected', false);
					$('option[value="select_all"]').closest('select').trigger('change');
				}
			});
			$(this).on('select2:unselecting', function(e) {
				// Prevent dropdown from opening after unselecting
				$(this).one('select2:opening', function(e) {
					e.preventDefault();
				});
			});
		})

		// Custom clear button for contact select
		var $contactSelect = $('select[name="contact"]');
		if ($contactSelect.length) {
			var $container = $contactSelect.next('.select2-container');
			var $clearBtn = $('<button type="button" class="select2-custom-clear" style="display:none;"><span class="material-symbols-outlined">backspace</span></button>');
			$container.after($clearBtn);

			// Show/hide clear button based on selections
			var updateClearButton = function() {
				if ($contactSelect.val() && $contactSelect.val().length > 0) {
					$clearBtn.show();
				} else {
					$clearBtn.hide();
				}
			};

			// Clear selections on click
			$clearBtn.on('click', function() {
				$contactSelect.val(null).trigger('change');
				$(this).hide();
			});

			// Update button visibility on change
			$contactSelect.on('change', updateClearButton);
			updateClearButton();
		}

		self.find('.period-date-picker').each(function(){
			var field = $(this);
			field.datetimepicker({
				widgetPositioning: {
					horizontal: 'right'
				},
				icons: {
					time: "fa fa-clock-o",
					date: "fa fa-calendar",
					up: "fa fa-arrow-up",
					down: "fa fa-arrow-down",
					previous: 'fa fa-arrow-left',
					next: 'fa fa-arrow-right'
				},
				format: 'YYYY-MM-DD',
				locale: 'fr-ca'
			})
			field.datetimepicker().on('dp.change', self.period_changed)
		});
		self.find('select[name="year_start"]').on('change', self.year_changed)
		self.find('select[name="year_end"]').on('change', self.year_changed)
		self.find('input[name="period_type"]').on('change', self.period_type_changed)
		return self;
	}();
}

$.fn.Rapport = function() {
	var self = this;
	self.table = undefined;
	self.filters = undefined;
	self.button = $('.btn-rapport');
	self.reset_button = $('.btn-reset-rapport');

	self.reset = function() {
		$('#custom-search input').val('')
		$('select[name="contact"] option:selected').prop('selected', false).change()
		$('input[type="checkbox"]').prop('checked', false)
		$('input[type="checkbox"][value="subtotal"]').prop('checked', true)
		$('input[type="checkbox"][value="due"]').prop('checked', true)
		$('input[type="radio"][name="period_type"][value="years"]').prop('checked', true).change()
		$('select[name="year_start"] option[value="' + (new Date().getFullYear()) + '"]').prop('selected', true).change()
		$('select[name="year_end"] option[value="' + (new Date().getFullYear()) + '"]').prop('selected', true).change()
		self.table.reset()
		self.button.click()
	}

	return function() {
		self.table = self.find('.rapport-table').RapportTable(self);
		self.filters = $('.rapport-filters').RapportFilters(self);
		self.button.on('click', self.table.update)
		self.reset_button.on('click', self.reset)
		self.reset()
		return self;
	}()
}
